import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
    addJob,
    deleteJob,
    editJob,
    getJobs,
    getJob,
} from "./jobAPI";

const initialState = {
    jobs: [],
    isLoading: false,
    isError: false,
    error: "",
};

// async thunks
export const fetchJobs = createAsyncThunk("job/fetchJobs",
    async () => {
        return await getJobs();
    }
);

export const fetchJob = createAsyncThunk("job/fetchJob",
    async (id) => {
        return await getJob(id);
    }
);

export const createJob = createAsyncThunk("job/createJob",
    async (data) => {
        return await addJob(data);
    }
);

export const updateJob = createAsyncThunk("job/updateJob",
    async ({ id, data }) => {
        return  await editJob(id, data);
    }
);

export const removeJob = createAsyncThunk("job/removeJob",
    async (id) => {
        return await deleteJob(id);
    }
);

// create slice
const jobSlice = createSlice({
    name: "job",
    initialState,
    
    extraReducers: (builder) => {
        builder
            .addCase(fetchJobs.pending, (state) => {
                state.isError = false;
                state.isLoading = true;
            })
            .addCase(fetchJobs.fulfilled, (state, action) => {
                state.isError = false;
                state.isLoading = false;
                state.jobs = action.payload;
            })
            .addCase(fetchJobs.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.error = action.error?.message;
                state.jobs = [];
            })
            // create job
            .addCase(createJob.pending, (state) => {
                state.isError = false;
                state.isLoading = true;
            })
            .addCase(createJob.fulfilled, (state, action) => {
                state.isError = false;
                state.isLoading = false;
                state.jobs.push(action.payload);
            })
            .addCase(createJob.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.error = action.error?.message;
            })
            // update job 
            .addCase(updateJob.pending, (state) => {
                state.isError = false;
                state.isLoading = true;
            })
            .addCase(updateJob.fulfilled, (state, action) => {
                state.isError = false;
                state.isLoading = false;

                const index = state.jobs.findIndex((job) => job.id === action.payload.id);

                state.jobs[index] = action.payload;
            })
            .addCase(updateJob.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.error = action.error?.message;
            })

            // delete job
            .addCase(removeJob.pending, (state) => {
                state.isError = false;
                state.isLoading = true;
            })
            .addCase(removeJob.fulfilled, (state, action) => {
                state.isError = false;
                state.isLoading = false;

                state.jobs = state.jobs.filter((job) => job.id !== action.meta.arg);
            })
            .addCase(removeJob.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.error = action.error?.message;
            });
    },
});

export default jobSlice.reducer;
